import Box from '@mui/material/Box';
import Button from '@mui/material/Button';
import Stack from '@mui/material/Stack';
import React, { memo } from 'react';

import { FormattedMessage } from '../../../util/reactIntl';

// From lg the buttons sit in a sticky column next to the filters. Below lg the list column
// is too narrow for that (the map cuts the column off), so they stack under the filters.
const SearchFiltersSecondaryComponentStyles = {
  flexGrow: 1,
  display: 'flex',
  flexDirection: { xs: 'column', lg: 'row' },
  justifyContent: 'space-between',
};

const buttonColumnStyles = {
  position: 'relative',
  marginLeft: { xs: 0, lg: 4 },
};

const buttonWrapperStyles = {
  position: { xs: 'static', lg: 'sticky' },
  top: 100,
  padding: { xs: '8px 0 24px', lg: '24px 0' },
  margin: { xs: 0, lg: '24px 0' },
  '& > button': { flex: { xs: 1, lg: 'none' } },
};

const SearchFiltersSecondaryComponent = ({
  cancelFilters: cancelFiltersFn,
  resetAll: resetAllFn,
  applyFilters,
  onClosePanel,
  children,
}) => {
  const applyFiltersWrapper = () => {
    // Ensure that panel closes (if now changes have been made)
    applyFilters();
    onClosePanel();
  };

  const cancelFilters = () => {
    if (cancelFiltersFn) {
      cancelFiltersFn();
    }
    onClosePanel();
  };

  const resetAll = (e) => {
    if (resetAllFn) {
      resetAllFn(e);
    }
    // Ensure that panel closes (if now changes have been made)
    onClosePanel();
    // blur event target if event is passed
    if (e && e.currentTarget) {
      e.currentTarget.blur();
    }
  };

  return (
    <Box sx={SearchFiltersSecondaryComponentStyles}>
      <Box flex={1}>{children}</Box>
      <Box sx={buttonColumnStyles}>
        <Stack direction={{ xs: 'row', lg: 'column' }} spacing={2} sx={buttonWrapperStyles}>
          <Button color="secondary" onClick={applyFiltersWrapper} variant="outlined">
            <FormattedMessage id="SearchFiltersSecondary.apply" />
          </Button>
          <Button color="secondary" onClick={cancelFilters} variant="outlined">
            <FormattedMessage id="SearchFiltersSecondary.cancel" />
          </Button>
          <Button color="secondary" onClick={resetAll} variant="outlined">
            <FormattedMessage id="SearchFiltersSecondary.resetAll" />
          </Button>
        </Stack>
      </Box>
    </Box>
  );
};

SearchFiltersSecondaryComponent.displayName = 'SearchFiltersSecondary';

const SearchFiltersSecondary = memo(SearchFiltersSecondaryComponent);

export default SearchFiltersSecondary;
